import {
    IRef,
} from './types';

import {
    useDefaultedRef,
} from 'tools/hooks';

export function useDateTimeInputRef() {
    return useDefaultedRef<IRef>({
        getValue(): Date | null {
            return null;
        },
        setValue(): void {
            return;
        },
        validate(): boolean {
            return true;
        },
    });
}
